(function (app) {
    app.constant("apiKeys", {
        "amplitudeKey": "45e8b609a44e2356fbb4366fa6840b76",
        "googleAnalyticsKey": "UA-19217975-4"
    });
})(window.app);